import { createSelector } from 'reselect'

import { getPageData } from 'selectors/page'

export const getArtistProfileUrl = createSelector([getPageData], (pageData): string => {
  const artistInfo = pageData.artistInfo || {}
  return artistInfo.userName ? `/${artistInfo.userName}` : `/account/profile/${artistInfo.userId || ''}`
})
